import { AnyAction } from '@reduxjs/toolkit'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { mergeMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import { fetchBundles, fetchBundlesSuccess, fetchBundlesError } from './bundles.reducer'

import { GenericError, BundleType } from '../model/bundles.model'
import BundlesService from '../services/bundles.service'

import { RootState } from '~/core/store/root.reducer'

const fetchBundlesEpic: Epic<
  AnyAction,
  AnyAction,
  RootState,
  { bundlesService: BundlesService }
> = (action$, state$, { bundlesService }) =>
  action$.pipe(
    filter(fetchBundles.match),
    withLatestFrom(state$),
    mergeMap(([{ payload: { id, type, tariffId, tariffPrice } }]) =>
      from(
        type === BundleType.BONUS
          ? bundlesService.fetchBundles(tariffId)
          : bundlesService.fetchPromos(tariffId, tariffPrice),
      ).pipe(
        map((bundles) => fetchBundlesSuccess({ bundles, id, type })),
        catchError((error: GenericError) => of(fetchBundlesError({ id, type, ...error }))),
      ),
    ),
  )

const bundlesEpics = {
  fetchBundlesEpic,
}

export default bundlesEpics
